import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategoryNav() {
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            探索字幕资源
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
            按分类浏览日韩影视中文字幕资源，快速找到你想要的
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group flex flex-col items-center gap-3 p-6 rounded-2xl bg-background-100 hover:bg-primary-50 transition-all duration-300 cursor-pointer"
            >
              <span className="w-14 h-14 flex items-center justify-center rounded-2xl bg-primary-100 text-primary-500 group-hover:bg-primary-500 group-hover:text-background-50 transition-all duration-300">
                <i className={`${cat.icon} text-2xl`}></i>
              </span>
              <span className="font-heading text-sm font-semibold text-foreground-800 group-hover:text-primary-600 whitespace-nowrap">
                {cat.name}
              </span>
              <span className="text-xs text-foreground-500">{cat.articleCount} 篇资源</span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}